import React from 'react';
import { Form, Icon, Input, Button } from 'antd';
import * as R from 'ramda';
import emailImg from '../assets/images/icon_email_20.png';
import lockImg from '../assets/images/icon_lock_20.png';

const emailImage = () => (
    <img alt={'email'} src={emailImg} style={{ width: '20px', height: '20px', marginLeft: '-5px' }} />
);

const lockImage = () => (
    <img alt={'password'} src={lockImg} style={{ width: '20px', height: '20px', marginLeft: '-5px' }} />
);

const FormItem = Form.Item;

class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shouldShowResend: false,
        }
        this.handleOnReset = this.handleOnReset.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.handleOnResend = this.handleOnResend.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (R.isEmpty(prevProps.response.data)
            && this.props.response.data.status === 'fail') {
            const response = this.props.response.data.response;
            // notification['error']({
            //     message: '登入失敗',
            //     description: response.data.errors.message
            // });
    
            if (response.data.errors.code === 40101) {
                this.setState({
                    shouldShowResend: true,
                });
            }
        }
    }

    handleOnSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onSubmit(values);
            }
        });
    }

    handleOnReset() {
        console.log('reset');
        this.props.onReset();
    }

    handleOnResend(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.onResend(values);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { isSubmitting } = this.props;
        const { shouldShowResend } = this.state;
        return (
            <Form onSubmit={this.handleOnSubmit} style={{ width: '90%' }}>
                <FormItem >
                    {getFieldDecorator('email', {
                        rules: [{
                            type: 'email',
                            required: true,
                            message: '請輸入正確的信箱格式，example@email.com'
                        }],
                    })(
                        <Input
                            prefix={<Icon component={emailImage} />}
                            placeholder="電子郵件地址"
                        />
                    )}
                </FormItem>
                {shouldShowResend ? 
                    <div className='login-resend'>                
                        <button onClick={this.handleOnResend}
                        className='login-resend-btn'
                    >重發驗證信
                </button></div> : null}
                <FormItem>
                    {getFieldDecorator('password', {
                        rules: [{
                            pattern: new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$'),
                            message: '請輸入6-20個字母和數字'
                        }],
                    })(
                        <Input.Password prefix={<Icon component={lockImage} />} type="password" placeholder="密碼" />
                    )}
                </FormItem>
                <div className="forgot-div">
                    <button className="forgot-btn" onClick={this.handleOnReset}>忘記密碼？</button>
                </div>
                <FormItem>
                    <Button type="primary"
                        htmlType="submit"
                        loading={isSubmitting}
                        style={{
                            width: '100%',
                            height: '42px',
                            opacity: '1',
                            borderRadius: '25px',
                            background: 'linear-gradient(to bottom, #f16071, #fdd667) 196%',
                            border: '0px'
                        }}>
                        登入
                    </Button>
                </FormItem>
            </Form>
        );
    }
}

export default Form.create()(LoginForm);
